// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field.only-two[data-v-ab572886] .control {\n\twidth: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
